import React from 'react';
import { Formik } from 'formik';
import { CSSTransition } from 'react-transition-group';
import './styles.css';
import BasicButton from '../../../../components/BasicButton';
import BasicButtonGroup from '../../../../components/BasicButtonGroup';
import BasicSubmitButton from '../../../../components/BasicSubmitButton';
import InputFileGroup from '../../../../components/InputFileGroup';
import LoadMask from '../../../../components/LoadMask';
import {ANIMATION_TIMEOUT_APPEAR} from '../../../../constants/animation';
import ENDPOINT from '../../../../constants/endpoints';
import useApi from '../../../../hooks/useApi';
import {ProfileAddFilesFormValidationSchema} from './validate';

const ProfileAddFilesForm = props => {
  const {
    params: { id: candidateId },
    actions: { proceed, dismiss },
  } = props;

  const api = useApi();

  const handleChangeFile = (
    name,
    index,
    value,
    { setFieldValue, setFieldTouched }
  ) => {
    setFieldValue(`${name}.${index}`, value, false);
    setFieldTouched(`${name}.${index}`, true, true);
  };

  const handleRemoveFile = (index, { arrayHelpers }) => {
    arrayHelpers.remove(index);
  };

  const sendFile = (
    file,
    { files, errors, index },
    { setFieldValue, setErrors }
  ) =>
    new Promise(resolve => {
      api.post(
        ENDPOINT.ACTION.ADDITIONAL_FILE.SAVE,
        { ...file, candidateId },
        {
          handleSuccess: () => {
            files.splice(index, 1);
            errors.splice(index, 1);
            setFieldValue('files', files, false);
            resolve(true);
          },
          handleError: ({ data: { message = 'ERROR' } }) => {
            errors[index] = message;
            setErrors({ files: errors });
            resolve(false);
          },
        }
      );
    });

  const handleSubmit = async (
    values,
    { setSubmitting, setFieldValue, setErrors }
  ) => {
    const params = {
      index: 0,
      files: [...values.files],
      errors: new Array(values.files.length),
    };
    for (let i = 0; i < values.files.length; i++) {
      const success = await sendFile(values.files[i], params, {
        setFieldValue,
        setErrors,
      });
      !success && ++params.index;
    }

    setSubmitting(false);
    if (!params.files.length) {
      proceed();
    }
  };

  return (
    <CSSTransition
      in={true}
      appear={true}
      timeout={ANIMATION_TIMEOUT_APPEAR}
      classNames="fade"
    >
      <div className="form__inner">
        <Formik
          initialValues={{ files: [] }}
          validationSchema={ProfileAddFilesFormValidationSchema}
          onSubmit={handleSubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            setFieldValue,
            setFieldTouched,
          }) => (
            <form
              onSubmit={handleSubmit}
              className="form__content"
              style={{ maxWidth: '100%' }}
            >
              {isSubmitting && <LoadMask />}

              <div
                className="form__group form__group--compact"
                style={{
                  maxWidth: '100%',
                  marginBottom: '15px',
                }}
              >
                <InputFileGroup
                  name="files"
                  values={values.files}
                  touched={touched.files}
                  errors={errors.files}
                  required={false}
                  onChange={(name, index, value, arrayHelpers) =>
                    handleChangeFile(name, index, value, {
                      setFieldValue,
                      setFieldTouched,
                      arrayHelpers,
                    })
                  }
                  onRemove={(index, arrayHelpers) =>
                    handleRemoveFile(index, { arrayHelpers })
                  }
                />
              </div>

              {!!values.files.length && (
                <>
                  <div className="form__controls form__controls--compact">
                    <BasicButtonGroup groupStyles={{ width: '100%' }}>
                      <BasicSubmitButton
                        controlFunc={handleSubmit}
                        btnWidth={200}
                        btnHeight={40}
                        btnFontWeight={500}
                        btnArrow={true}
                        btnTextColor="#27282d"
                        btnText="Upload"
                      />

                      <BasicButton
                        controlFunc={dismiss}
                        btnWidth={200}
                        btnHeight={40}
                        btnFontWeight={500}
                        btnArrow={false}
                        btnTextColor="#27282d"
                        btnText="Cancel"
                      />
                    </BasicButtonGroup>
                  </div>
                </>
              )}
            </form>
          )}
        </Formik>
      </div>
    </CSSTransition>
  );
};

export default ProfileAddFilesForm;
